class ArticleToc extends HTMLElement {
  connectedCallback() {
    if (this.dataset.showToc !== 'true') return;

    this.content = this.querySelector('[ref="content"]');
    this.nav = this.querySelector('[ref="tocNav"]');
    if (!this.content || !this.nav) return;

    const headings = this.content.querySelectorAll('h2, h3');
    if (headings.length < 2) {
      this.closest('.article-body')?.classList.add('article-body--no-toc');
      const sidebar = this.querySelector('.article-body__sidebar');
      if (sidebar) sidebar.hidden = true;
      return;
    }

    const usedIds = new Set();
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = heading.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || `section-${index}`;
        let id = base;
        let suffix = 1;
        while (usedIds.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) {
          id = `${base}-${suffix}`;
          suffix += 1;
        }
        heading.id = id;
      }
      usedIds.add(heading.id);

      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      if (heading.tagName === 'H3') link.style.paddingInlineStart = '1.6rem';
      this.nav.appendChild(link);
    });

    this.links = Array.from(this.nav.querySelectorAll('a'));

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const link = this.nav.querySelector(`a[href="#${CSS.escape(entry.target.id)}"]`);
          if (!link) return;
          if (entry.isIntersecting) {
            this.links.forEach((l) => l.classList.remove('is-active'));
            link.classList.add('is-active');
          }
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );

    headings.forEach((heading) => this.observer.observe(heading));

    this.nav.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      if (!link) return;
      event.preventDefault();
      const target = document.getElementById(link.getAttribute('href').slice(1));
      target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
}

if (!customElements.get('article-toc')) {
  customElements.define('article-toc', ArticleToc);
}
